(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ylb-catalog"]) return;
  try {
    
document.addEventListener('submit',event=>{
 const form=event.target.closest('[data-ylb-catalog-sort]');
 if(!form)return;
 event.preventDefault();
 const url=new URL(location.href);
 url.searchParams.set('sort_by',new FormData(form).get('sort_by'));
 url.searchParams.delete('page');
 url.hash='';
 location.assign(url);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ylb-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
 if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
 const link=event.target.closest('a[href]');
 if(!link||link.hasAttribute('download')||link.target&&link.target!=='_self')return;
 const menu=link.closest('.ylb-mobile-menu');
 if(menu)menu.open=false;
 const destination=new URL(link.href,location.href);
 if(destination.origin!==location.origin||destination.pathname.replace(/\/$/,'')!==location.pathname.replace(/\/$/,'')||!destination.hash||destination.hash==='#')return;
 let target;
 try{target=document.getElementById(decodeURIComponent(destination.hash.slice(1)));}catch{return;}
 if(!target)return;
 event.preventDefault();
 const address=new URL(location.href);
 address.hash=destination.hash;
 if(location.hash!==destination.hash)history.pushState(null,'',address);
 const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 target.scrollIntoView({behavior:reducedMotion?'instant':'smooth',block:'start'});
 if(!target.hasAttribute('tabindex')){
  target.setAttribute('tabindex','-1');
  target.addEventListener('blur',()=>target.removeAttribute('tabindex'),{once:true});
 }
 target.focus({preventScroll:true});
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.ylb-mobile-menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ylb-product-details"] && !Shopify.designMode) return;
  try {
    
function tidyYlbDescriptions(root=document){
 root.querySelectorAll('[data-ylb-description]').forEach(body=>{
  body.querySelectorAll('p').forEach(p=>{if(!p.textContent.trim()&&!p.querySelector('img,video,iframe,svg'))p.remove();});
  const last=body.lastElementChild;
  if(last&&/^H[2-6]$/.test(last.tagName))last.remove();
 });
}
tidyYlbDescriptions();
document.addEventListener('shopify:section:load',event=>tidyYlbDescriptions(event.target));

  } catch(e) { console.error(e); }
})();
})();
